<template>
  <div>
    <form id="form" @submit.prevent="">
      <div class="mb-15">
        <div class="form-group row align-items-center">
          <label class="col-lg-2 col-form-label">
            وضعیت
          </label>
          <div class="col-lg-6">
            <div class="radio-inline">
              <label for="lamp_status_0" class="radio">
                <input
                  type="radio"
                  value="1"
                  id="lamp_status_0"
                  v-model="form.lamp_status"
                />
                <span></span>
                روشن
              </label>
              <label for="lamp_status_1" class="radio">
                <input
                  type="radio"
                  value="0"
                  id="lamp_status_1"
                  v-model="form.lamp_status"
                />
                <span></span>
                خاموش
              </label>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-lg-2 col-form-label">رنگ</label>
          <div class="col-lg-6">
            <input
              type="color"
              class="form-control form-control-color"
              v-model.lazy="form.lamp_color"
            />
          </div>
        </div>
      </div>

      <div class="mb-3">
        <div class="form-group row">
          <label
            class="col-lg-2 col-form-label"
            @click="eventHub.$emit('update_device_llll', '12314')"
          >
            افکت
          </label>
          <div class="col-lg-6">
            <select class="form-control" v-model.lazy="form.effect">
              <option value="0">ندارد</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "RGB",
  data() {
    return {
      form: {}
    };
  },
  props: {
    status: String
  },
  computed: {
    ...mapGetters(["deviceTypes", "device"]),
    originalForm() {
      let status = this.device.status.toString();
      status = status === "" ? "00000" : status;

      return {
        lamp_status: status.charAt(0),
        lamp_color: status.slice(1, 4)
          ? "#" + this.to6Digit(status.slice(1, 4))
          : "#f6f6f6",
        effect: status.charAt(4)
      };
    }
  },
  beforeMount() {
    this.form = _.cloneDeep(this.originalForm);
  },
  watch: {
    form: {
      handler() {
        // if (_.isEqual(this.form, this.originalForm) === false) {
        this.$emit("change-form", this.getStatus());
        // }
      },
      deep: true
    },
    status: {
      handler() {
        this.form = _.cloneDeep(this.originalForm);
      }
    }
  },
  methods: {
    to6Digit(color) {
      return (
        color.charAt(0) +
        color.charAt(0) +
        color.charAt(1) +
        color.charAt(1) +
        color.charAt(2) +
        color.charAt(2)
      );
    },
    to3Digit(color) {
      let parts = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);

      if (parts === null) {
        return "000";
      }

      let r = parseInt(parts[1], 16);
      let g = parseInt(parts[2], 16);
      let b = parseInt(parts[3], 16);

      r = parseInt(r / 17).toString(16);
      g = parseInt(g / 17).toString(16);
      b = parseInt(b / 17).toString(16);

      return r + g + b;
    },
    getStatus() {
      return (
        this.form.lamp_status +
        this.to3Digit(this.form.lamp_color) +
        this.form.effect
      );
    }
  }
};
</script>
